"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentViewerEvent = void 0;
var ComponentViewerEvent;
(function (ComponentViewerEvent) {
    ComponentViewerEvent["FeatureStatusUpdated"] = "FeatureStatusUpdated";
})(ComponentViewerEvent || (exports.ComponentViewerEvent = ComponentViewerEvent = {}));
